import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useEffect, useState } from 'react';
import { chooseProfileFilter } from "../../helpers/chooseProfileFilter";
import sleep from "sleep-promise";

function Form() {
    const profileFilter = chooseProfileFilter()

    const hiddenValues = {}

    // Usuário vinculado a uma empresa: a empresa vem do profileFilter e o campo não é exibido
    if (profileFilter.gci_company_id) {
        hiddenValues.gci_company_id = profileFilter.gci_company_id
    }

    const { id } = useParams();
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);

    const endpointBackend = config.endpoints.backend;

    const paths = {
        endpointSave: `${endpointBackend}gci/service-contracts/save`,
        endpointGetAllCompanies: `${endpointBackend}gci/companies/getall`,
        endpointGetAllBankAccounts: `${endpointBackend}gci/bank-accounts/getall`,
        endpointGetAllClients: `${endpointBackend}gci/clients/getall`,
        endpointGetAllPaymentMethods: `${endpointBackend}gci/payment-methods/getall`,
        endpointGetAllAccountingPlans: `${endpointBackend}gci/accounting-plans/getall`,
        endpointGetById: `${endpointBackend}gci/service-contracts/getById`,
        urlGoBack: `/gci/service-contracts/list`,
        pathView: `/gci/service-contracts/view`
    }

    const labels = {
        labelTitleAdd: "Novo Contrato de Prestação de Serviços",
        labelTitleEdit: "Editar Contrato de Prestação de Serviços",
        labelTitleView: 'Visualizar Contrato de Prestação de Serviços'
    }

    const reloadForm = async (values) => {
        const form = getForm(values);
        setForm(form);
        setFormContent(<></>);
        await sleep(1);
        setFormContent(
            <CustomFormContainer
                form={form}
                content={<CustomForm form={form} />}
            />)
    }

    const getForm = (values) => {
        const companyId = profileFilter.gci_company_id || values.gci_company_id || null;

        let form = {
            hiddenValues,
            fields: [
                !profileFilter.gci_company_id ? {
                    name: 'gci_company_id',
                    type: 'select',
                    label: 'Empresa',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllCompanies,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    readOnly: !!id,
                    handleChange: async (element, field, values) => {
                        values.gci_bank_account_id = null;
                        values.clients = null;
                        values.payment_methods = [];

                        await reloadForm(values);
                    },
                    columnSize: 12
                } : {},
                {
                    name: 'gci_bank_account_id',
                    type: 'select',
                    label: 'Conta Bancária',
                    options: [],
                    // Sem empresa definida não lista nenhuma conta
                    ...(companyId ? {
                        optionsEndpoint: {
                            endpoint: paths.endpointGetAllBankAccounts,
                            label: 'full_name',
                            value: 'id',
                            params: {
                                filter: {
                                    gci_company_id: companyId
                                }
                            }
                        }
                    } : {}),
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'identification',
                    type: 'text',
                    label: 'Número do Contrato',
                    validations: {
                        required: false
                    },
                    columnSize: 6
                },
                {
                    name: 'status',
                    type: 'select',
                    label: 'Status',
                    options: [
                        { label: 'Ativo', value: 'active' },
                        { label: 'Inativo', value: 'inactive' },
                        { label: 'Projeção', value: 'projection' }
                    ],
                    validations: {
                        required: true
                    },
                    columnSize: 6
                },
                {
                    name: 'description',
                    type: 'textarea',
                    label: 'Descrição',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'start_date',
                    type: 'date',
                    label: 'Início da Vigência',
                    validations: {
                        required: false
                    },
                    columnSize: 4
                },
                {
                    name: 'end_date',
                    type: 'date',
                    label: 'Fim da Vigência',
                    validations: {
                        required: false
                    },
                    columnSize: 4
                },
                {
                    name: 'value',
                    type: 'decimal',
                    label: 'Valor do Contrato',
                    validations: {
                        required: true
                    },
                    columnSize: 4
                },
                {
                    name: 'clients',
                    type: 'multiinput',
                    label: 'Cliente (s)',
                    sortBy: 'index',
                    showDeleteButton: true,
                    form: [
                        {
                            name: 'gci_client_id',
                            type: 'select',
                            label: 'Cliente',
                            options: [],
                            optionsEndpoint: {
                                endpoint: paths.endpointGetAllClients,
                                label: 'name',
                                value: 'id',
                                params: {
                                    filter: {
                                        ...profileFilter,
                                        gci_company_id: companyId,
                                    }
                                }
                            },
                            validations: {
                                required: true
                            }
                        }
                    ],
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'payment_methods',
                    type: 'multiinput',
                    label: 'Formas de Pagamento',
                    sortBy: 'index',
                    form: [
                        {
                            name: 'gci_accounting_plan_id',
                            type: 'select',
                            label: 'Plano de Contas',
                            options: [],
                            optionsEndpoint: {
                                endpoint: paths.endpointGetAllAccountingPlans,
                                label: 'full_path',
                                value: 'id',
                                params: {
                                    filter: {
                                        ...profileFilter,
                                        gci_company_id: companyId,
                                        onlyLastLevel: true
                                    }
                                }
                            },
                            validations: {
                                required: true
                            },
                            styleTh: { width: '20%' }
                        },
                        {
                            name: 'gci_payment_method_id',
                            type: 'select',
                            label: 'Forma de Pagamento',
                            options: [],
                            optionsEndpoint: {
                                endpoint: paths.endpointGetAllPaymentMethods,
                                label: 'name',
                                value: 'id',
                                params: {
                                    filter: {
                                        type: ['revenue', 'both']
                                    }
                                }
                            },
                            validations: {
                                required: true
                            },
                            styleTh: { width: '20%' }
                        },
                        {
                            name: 'number_of_installments',
                            type: 'integer',
                            label: 'Parcelas',
                            validations: {
                                required: true
                            },
                            styleTh: { width: '9%' }
                        },
                        {
                            name: 'amount',
                            type: 'decimal',
                            label: 'Valor Parcela',
                            validations: {
                                required: true
                            }
                        },
                        {
                            name: 'periodicity',
                            type: 'integer',
                            label: 'Periodicidade (dias)',
                            validations: {
                                required: false
                            },
                            styleTh: { width: '12%' }
                        },
                        {
                            name: 'initial_date',
                            type: 'date',
                            label: 'Data da Primeira Parcela',
                            validations: {
                                required: true
                            },
                            styleTh: { width: '15%' }
                        }
                    ],
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'file',
                    type: 'fileS3',
                    label: 'Arquivo',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'observation',
                    type: 'textarea',
                    label: 'Observações',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels,
        }

        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            } else {
                values.status = 'active';
            }

            const form = getForm(values);

            setForm(form);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}

export default Form;
